import { render, staticRenderFns } from "./AddPositionModal.vue?vue&type=template&id=bf31c288&scoped=true&"
import script from "./AddPositionModal.vue?vue&type=script&lang=ts&"
export * from "./AddPositionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf31c288",
  null
  
)

export default component.exports